import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {ListComponent } from './list/list.component'
import {DetailsComponent } from './details/details.component'
import { WorkflowBuilderComponent } from './workflow/builder/workflow-builder.component';
import { SSOLoginComponent } from './ssologin/ssologin.component';

const routes: Routes = [
  {
    path:'sso',
    component: SSOLoginComponent
  },
  {
    path:'dynamicforms/edit/:id',
    component: DetailsComponent
  },
  {
    path:'workflow',
    component: WorkflowBuilderComponent
  },
  {
    path:'workflow/:id',
    component: WorkflowBuilderComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
